import classNames from 'classnames';
import React from 'react';
import { DesktopNavigatorTabFragment } from '../../../../../generated/types';
import { DesktopSiteNavListColumnV2 } from './DesktopSiteNavListColumnV2';
import { DesktopSiteNavEditorialColumn } from './DesktopSiteNavEditorialColumn';

import './DesktopSiteNavPulldownV2.scss';

interface Props {
  tab: DesktopNavigatorTabFragment;
  active: boolean;
  hovered: boolean;
}

export const DesktopSiteNavPulldownV2: React.FC<Props> = ({ tab, active, hovered }) => (
  <div
    className={classNames('DesktopSiteNavPulldownV2', {
      'DesktopSiteNavPulldownV2--hidden': !(hovered && active)
    })}
  >
    {tab.units.map((unit, index) => {
      switch (unit.__typename) {
        case 'ListNavigatorUnit':
          return (
            <>
              <DesktopSiteNavListColumnV2
                className="DesktopSiteNavPulldownV2__column"
                content={unit}
                key={index}
              />
            </>
          );

        case 'EditorialNavigatorUnit':
          return (
            <DesktopSiteNavEditorialColumn
              key={index}
              className="DesktopSiteNavPulldownV2__column"
              content={unit}
              active={active}
            />
          );
      }
    })}
  </div>
);
